module.exports = __webpack_public_path__ + "static/shoper_doskonaly_sposob_sprzedazy_w_internecie_og-e7c11221d526b6eb70266f08f808792c.png";